import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ItemAcertoPonto, PreviewAcertoPonto } from '../../api.service';

@Component({
  selector: 'app-modal-acerto-ponto',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-acerto-ponto.component.html',
  styleUrls: ['../../shared/modal-pesquisa-lista.component.css', './modal-acerto-ponto.component.css']
})
export class ModalAcertoPontoComponent implements OnChanges {
  @Input() aberta = false;
  @Input() carregando = false;
  @Input() confirmando = false;
  @Input() preview: PreviewAcertoPonto | null = null;

  @Output() fechar = new EventEmitter<void>();
  @Output() confirmar = new EventEmitter<string[]>();

  selecionados = new Set<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['preview'] || changes['aberta']) {
      this.selecionados = new Set();
    }
  }

  hora(item: ItemAcertoPonto) {
    const instante = item.criadoEm ? new Date(item.criadoEm) : null;
    if (!instante || Number.isNaN(instante.getTime())) {
      return item.criadoEm || '-';
    }
    return instante.toLocaleString('pt-BR');
  }

  marcado(eventoId: string) {
    return this.selecionados.has(eventoId);
  }

  alternar(eventoId: string, marcado: boolean) {
    if (marcado) {
      this.selecionados.add(eventoId);
      return;
    }
    this.selecionados.delete(eventoId);
  }

  marcarTodos() {
    (this.preview?.candidatos || []).forEach(item => this.selecionados.add(item.eventoId));
  }

  limparSelecao() {
    this.selecionados = new Set();
  }

  confirmarSelecionados() {
    this.confirmar.emit([...this.selecionados]);
  }
}
